module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/boombox.png?66abdd10c33cad6a2edaeb783b0e895a";